module.exports = __webpack_public_path__ + "img/yh_06.8e0ec8ad.png";